export function limitStringLength(data: string, limitLength: number, postfix: string) {
  return data.length > limitLength ? (data.slice(0, limitLength - postfix.length) + postfix) : data
}